import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import TextEditor from '../../../../components/TextEditor'
import { axiosInstance } from '../../../../const/axiosInstance'
import styles from './edit.module.css'

export default function EditJob({add}) {
    const [job, setJob] = useState({})
    const [name, setName] = useState('')
    const [information, setInformation] = useState('<p></p>')
    const [language, setLenguage] = useState("")
    const [fromLang, setFromLang] = useState(false)

    const {id} = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        (async () => {
            if(!add){
                const res = await axiosInstance.get(`/use/career/${id}`)
                if(res.data.status){
                    setJob(res.data.data)
                }
            }
            setLenguage("arm")
            })()
    },[])

    useEffect(() => {
        if( name !== "" && information !== '' && information !== '<p></p>\n'){
            setJob(prev => ({...prev, [`${language}name`]: name, [`${language}information`]: information }))
        }
    }, [information, name])

    useEffect(() => {
        if(language){
            if(!add){
                setFromLang(true)
                setName(job[`${language}name`])
                setInformation(job[`${language}information`])
            }else{
                setName("")
                setInformation("")
            }
        }
    }, [language])


    const changeLanguage = async () => {
        if(name && information){
            if(language == "arm"){
               setLenguage("ru")
            }
            if(language == "ru"){
                setLenguage("eng")
            }
        }else{
            return 
        }
    }

    const addJob = async () => {
        await axiosInstance.post(`/admin/career/add`, job)
        navigate("/dashboard/career")
    }

    const editJob = async () => {
        await axiosInstance.post(`/admin/career/edit`, job)
        navigate("/dashboard/career")
    }
  
  return (
    <div className={styles['edit-part']}>
        <h2>{language == "arm" ? "Հայերեն" : language == "ru" ? "Ռուսերեն" : "Անգլերեն"}</h2>
        <div className={styles['info']}>
            <p>Աշխատանքի անվանում։ </p>
            <input type='text' placeholder='Աշխատանքի անվանում' value={name} onChange={(e) => setName(e.target.value)}/>
        </div>
        <div>
            <p>Աշխատանքի մասին: </p>
            <TextEditor setInformation={setInformation} information={information} fromLang={fromLang} setFromLang={setFromLang}/>
        </div>
        <div className={styles['btn-div']}>
            {language != "eng" ? 
                    <button className={`${styles['btn']} ${styles['confirm']}`} onClick={changeLanguage}>Հաջորդ</button> 
                    : !name || !information || information == '<p></p>\n' ? <button disabled className={`${styles['btn']} ${styles['confirm']}`}>Հաստատել</button>
                    :
                    <button className={`${styles['btn']} ${styles['confirm']}`} onClick={add ? addJob : editJob}>Հաստատել</button>}
            <Link to='/dashboard/career'><button className={`${styles['btn']} ${styles['cancel']}`}>Չեղարկել</button></Link>
        </div>
    </div>
  )
}